var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "script" } },
      [
        _c(
          "b-modal",
          {
            attrs: {
              visible: _vm.show,
              id: "terms-of-use-modal",
              size: "lg",
              centered: "",
              title: _vm.$t("TermsOfUse.HeaderTitle"),
              "no-close-on-esc": _vm.loggedIn,
              "no-close-on-backdrop": _vm.loggedIn,
              "hide-header-close": true
            },
            on: { hide: _vm.onHide },
            scopedSlots: _vm._u([
              {
                key: "modal-header",
                fn: function() {
                  return [
                    _c(
                      "h2",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "terms-of-use-modal___BV_modal_title_" }
                      },
                      [_vm._v(_vm._s(_vm.termsTitle))]
                    ),
                    _vm._v(" "),
                    _c("language-selection")
                  ]
                },
                proxy: true
              },
              {
                key: "modal-footer",
                fn: function() {
                  return [
                    !_vm.loggedIn
                      ? _c("div", { staticClass: "w-100 centered" }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: {
                                    content: _vm.$t(
                                      "TermsOfUse.AcceptTermsRequiredToContinueRegistration"
                                    )
                                  },
                                  expression:
                                    "{ content: $t('TermsOfUse.AcceptTermsRequiredToContinueRegistration') }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass: "btn btn-secondary btn-all",
                              attrs: { type: "button", id: "setTermsReadBtn" },
                              on: { click: _vm.setRead }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("TermsOfUse.HaveRead")) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "TermsOfUse.AcceptTermsRequiredToContinueRegistration"
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loggedIn
                      ? _c("div", { staticClass: "w-100 centered" }, [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip.top.center",
                                  value: {
                                    content: _vm.$t(
                                      "TermsOfUse.TermsNotAcceptedLogout"
                                    )
                                  },
                                  expression:
                                    "{ content: $t('TermsOfUse.TermsNotAcceptedLogout') }",
                                  modifiers: { top: true, center: true }
                                }
                              ],
                              staticClass: "btn btn-negative",
                              attrs: { type: "button", id: "rejectTermsBtn" },
                              on: { click: _vm.rejectTerms }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("TermsOfUse.RejectTerms")) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("TermsOfUse.TermsNotAcceptedLogout")
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-all",
                              attrs: { type: "button" },
                              on: { click: _vm.acceptTerms }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("TermsOfUse.AcceptTerms")) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          },
          [
            _vm._v(" "),
            _c("div", {
              style: { "max-height": _vm.winHeight, overflow: "auto" },
              domProps: { innerHTML: _vm._s(_vm.termsBody) }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }